export default __webpack_public_path__ + "static/media/pic3.91cd699e.jpg";